export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const REGISTER = "REGISTER";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const USER_PROFILE = "USER_PROFILE";
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_FAILURE = "USER_PROFILE_FAILURE";

export const SETTINGS = "SETTINGS";
export const SETTINGS_SUCCESS = "SETTINGS_SUCCESS";
export const SETTINGS_FAILURE = "SETTINGS_FAILURE";

export const PASSWORD_AUTHENTICATE = "PASSWORD_AUTHENTICATE";
export const PASSWORD_AUTHENTICATE_SUCCESS = "PASSWORD_AUTHENTICATE_SUCCESS";
export const PASSWORD_AUTHENTICATE_FAILURE = "PASSWORD_AUTHENTICATE_FAILURE";

export const RESET_PASSWORD_AUTHENTICATE = "RESET_PASSWORD_AUTHENTICATE";

export const RESET_AUTH_STATE = "RESET_AUTH_STATE";

export const GET_CURRENT_LOCATION = "GET_CURRENT_LOCATION";
export const LOGOUT = "LOGOUT";

export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

export interface AuthState {
  location_address: string | null;
  user: any;
  success: string | null;
  error: string | null;
  loading: boolean;
  systemSettings: any;
  passwordAuthenticate: boolean;
  otpVerifiedToken: string | null;

}

interface LoginSuccessAction {
  type: typeof LOGIN_SUCCESS;
  payload: any;
}

interface RegisterAction {
  type: typeof REGISTER;
  payload: any;
}

interface RegisterSuccessAction {
  type: typeof REGISTER_SUCCESS;
  payload: any;
}

interface LoginFailureAction {
  type: typeof LOGIN_FAILURE;
  payload: string;
}

interface RegisterFailureAction {
  type: typeof REGISTER_FAILURE;
  payload: string;
}

interface GetCurrentLocation {
  type: typeof GET_CURRENT_LOCATION;
  payload: string;
}

interface LogoutAction {
  type: typeof LOGOUT;
}

interface ChangePassword {
  type: typeof CHANGE_PASSWORD;
  payload: any;
}

interface ChangePasswordSuccess {
  type: typeof CHANGE_PASSWORD_SUCCESS;
  payload: any;
}

interface ChangePasswordFailure {
  type: typeof CHANGE_PASSWORD_FAILURE;
  payload: string;
}

interface ResetPassword {
  type: typeof RESET_PASSWORD;
  payload: any;
}

interface ResetPasswordSuccess {
  type: typeof RESET_PASSWORD_SUCCESS;
  payload: any;
}

interface ResetPasswordFailure {
  type: typeof RESET_PASSWORD_FAILURE;
  payload: string;
}

interface UserProfile {
  type: typeof USER_PROFILE;
  payload: any;
}

interface UserProfileSuccess {
  type: typeof USER_PROFILE_SUCCESS;
  payload: any;
}

interface UserProfileFailure {
  type: typeof USER_PROFILE_FAILURE;
  payload: string;
}

interface Settings {
  type: typeof SETTINGS;
  payload: any;
}

interface SettingsSuccess {
  type: typeof SETTINGS_SUCCESS;
  payload: any;
}

interface SettingsFailure {
  type: typeof SETTINGS_FAILURE;
  payload: string;
}

interface PasswordAuthenticate {
  type: typeof PASSWORD_AUTHENTICATE;
  payload: any;
}

interface PasswordAuthenticateSuccess {
  type: typeof PASSWORD_AUTHENTICATE_SUCCESS;
  payload: any;
}

interface PasswordAuthenticateFailure {
  type: typeof PASSWORD_AUTHENTICATE_FAILURE;
  payload: string;
}

interface ResetPasswordAuthenticate {
  type: typeof RESET_PASSWORD_AUTHENTICATE;
}

interface ResetAuthAction {
  type: typeof RESET_AUTH_STATE;
}

interface VerifyOtpAction {
  type: typeof VERIFY_OTP;
  payload: any;
}

interface VerifyOtpSuccessAction {
  type: typeof VERIFY_OTP_SUCCESS;
  payload: any;
}

interface VerifyOtpFailureAction {
  type: typeof VERIFY_OTP_FAILURE;
  payload: string;
}

export type AuthActionTypes =
  | UserProfile
  | UserProfileSuccess
  | UserProfileFailure
  | GetCurrentLocation
  | LoginSuccessAction
  | RegisterSuccessAction
  | ChangePassword
  | ChangePasswordSuccess
  | ChangePasswordFailure
  | Settings
  | SettingsSuccess
  | SettingsFailure
  | ResetPassword
  | ResetPasswordSuccess
  | ResetPasswordFailure
  | LoginFailureAction
  | RegisterAction
  | RegisterFailureAction
  | LogoutAction
  | PasswordAuthenticate
  | PasswordAuthenticateSuccess
  | PasswordAuthenticateFailure
  | ResetPasswordAuthenticate
  | ResetAuthAction
  | VerifyOtpAction
  | VerifyOtpSuccessAction
  | VerifyOtpFailureAction;
